var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "day-wrapper",
        { "hover-active": _vm.day.isHoverActive },
        { "hover-allowed": !!_vm.day.hoverColors },
      ],
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
        mouseover: function ($event) {
          return _vm.$emit("mouseover")
        },
        mouseleave: function ($event) {
          return _vm.$emit("mouseleave")
        },
      },
    },
    [
      _vm.day.someToolTip && _vm.day.tooltipVisible
        ? _c("ToolTip", {
            attrs: { "day-key": _vm.dayKey, "tool-tip": _vm.day.someToolTip },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.backgroundBefore
        ? _c("div", { class: ["before", "bg-" + _vm.backgroundBefore] })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "calendar-day", class: _vm.day.additionalClassList },
        [
          _c(
            "div",
            {
              class: [
                "day-text text-" + _vm.day.colors.text,
                _vm.day.colors.underline
                  ? "border-b-2 border-" + _vm.day.colors.underline
                  : "",
              ],
            },
            [_vm._v("\n      " + _vm._s(_vm.day.label) + "\n    ")]
          ),
          _vm._v(" "),
          _vm.day.dayPrice
            ? _c("div", {
                class: [
                  "day-price",
                  _vm.day.colors.price ? "text-" + _vm.day.colors.price : "",
                ],
                domProps: {
                  innerHTML: _vm._s(_vm.day.dayPrice.toStringLimitedSpace()),
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.backgroundAfter
        ? _c("div", { class: ["after", "bg-" + _vm.backgroundAfter] })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }